import React from "react";
import classNames from "classnames";
import Lottie from "react-lottie-player";

import lottieJson from "@animations/tix-loader.json";
import Button from "../Button/Button";

import "./SendButton.scss";

interface SendButtonProps {
  loading?: boolean;
  children: React.ReactNode | React.ReactElement;
  className?: string;
  onClick?(): void;
}

const SendButton = ({ loading, children, className, onClick }: SendButtonProps) => {
  const classes = classNames("send-button", className);

  return (
    <Button variant="secondary" loading={loading} onClick={onClick} className={classes}>
      {loading && (
        <Lottie
          loop
          animationData={lottieJson}
          play
          speed={1.2}
          style={{ flex: 1, display: "flex", alignItems: "center" }}
        />
      )}

      {children}
    </Button>
  );
};

export default SendButton;
